"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WiFiNetworksFromCsv = exports.CsvRow = exports.SEPARATOR = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../schema");
const common_1 = require("./common");
const NAMESPACE = 'Network.WiFi.Survey.Csv';
exports.SEPARATOR = ',';
exports.CsvRow = (0, schema_1.CapturePattern)(/^(?<bssid>.*),(?<channel>\d*),(?<rssi>-\d*)$/, effect_1.Schema.Struct({
    bssid: effect_1.Schema.String,
    channel: effect_1.Schema.NumberFromString,
    rssi: effect_1.Schema.NumberFromString,
})).annotations({ identifier: `${NAMESPACE}.CsvRow` });
exports.WiFiNetworksFromCsv = effect_1.Schema.String.pipe(effect_1.Schema.compose(effect_1.Schema.split('\n')), effect_1.Schema.compose(effect_1.Schema.Array(exports.CsvRow.pipe(effect_1.Schema.compose(common_1.WiFiNetwork))))).annotations({
    identifier: `${NAMESPACE}.WiFiNetworksFromCsv`,
    documentation: 'A Schema used for decoding an array of Wi-Fi networks from a csv.\n' +
        'The column layout is as follows:\n' +
        'bssid | channel | rssi\n' +
        'Rows are separated by a newline character.',
});
//# sourceMappingURL=csv.js.map